let code = 'pspgestao';
let codeAPI = 'psp';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};